import Stats from 'stats.js';
import { addToRenderLoop } from './renderLoop';
import { isDebugging } from './urlParams';

if (isDebugging) {
  const stats = new Stats();
  stats.showPanel( 0 ); // 0: fps, 1: ms, 2: mb, 3+: custom
  document.body.appendChild( stats.dom );

  addToRenderLoop(() => stats.update());
}
